'use client';

import { Box } from '@osmosis/tailwind-ui/components/Box';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { bg0 } from '@osmosis/tailwind-ui/styles/background';
import { borderNeutral300 } from '@osmosis/tailwind-ui/styles/border';
import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * LearnFeature — the unified header + video "feature" box. Height syncing with
 * the AI panel is handled by `LearnFeatureGroup`, which wraps this box together
 * with the admin toolbar.
 */
const LearnFeature = ({ children, className }: Props) => (
  <Box
    data-testid="learn-feature"
    className={cn(
      'flex flex-col overflow-hidden rounded-lg border',
      borderNeutral300,
      bg0,
      className,
    )}
  >
    {children}
  </Box>
);

export default LearnFeature;
